<template>
  <div
    v-clickoutside="close"
    :class="['by-autocomplete', { autocomplete__open: popVisible }]"
  >
    <div @click="openPop" :style="{}" :class="['input-container']">
      <input
        readonly="readonly"
        @focus="handleFocus"
        @blur="handleBlur"
        v-bind="[$props, $attrs]"
        class="by-input__inner"
        v-model="inputLabel"
      />
      <!-- 前置内容 -->
      <span class="input__suffix">
        <!-- <slot name="suffix"> </slot> -->
        <svg-icon style="color: #fff" size="20" name="arrow-down"></svg-icon>
      </span>
    </div>
  <transition name="el-zoom-in-top" >
    <div v-show="popVisible" class="by-autocomplete-suggestion">
      <el-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list"
        max-height="50px"
        height="50px"
      >
        <li
          @click="handleClick(item)"
          class="li-item"
          v-for="(item, index) in data"
          :key="index"
        >
          <slot :item="item">
            {{ item["label"] }}
          </slot>
        </li>
        <li class="li-item li-nodata" v-if="data.length === 0">No Data</li>
        <slot></slot>
      </el-scrollbar>
    </div>
  </transition>

  </div>
</template>
  
  <script>
export default {
  inheritAttrs: false,
  model: {
    prop: "vModel",
    event: "vModelEvent",
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
    vModel: {
      type: String,
    },
  },

  data() {
    return {
      popVisible: false,
      inputLabel: "",
    };
  },
  watch: {
    vModel() {
      this.setOption();
    },
  },
  mounted() {
    this.setOption();
  },
  methods: {
    setOption() {
      this.inputLabel = this.data.find((item) => {
        return item.value === this.vModel;
      }).label;

      // this.$emit('vModelEvent',this.inputLabel)
    },
    openPop() {
      this.popVisible = !this.popVisible;
    },
    handleFocus(e) {
      // this.popVisible = true;
    },
    handleBlur() {
      if (this.data.length === 0) {
        this.$emit("vModelEvent", "");
        return;
      }
    },

    handleClick(item) {
      // debugger
      this.$emit("vModelEvent", item.value);
      this.close();
    },
    //关闭弹框
    close() {
      this.popVisible = false;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.by-autocomplete {
  height: 40px;
  box-sizing: border-box;
  .input-container {
    font-size: 15px;
    padding-right: 17px;
    position: relative;
    height: 100%;
    background-color: #89a4d7;
    border-radius: 20px;
    display: flex;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease-out
  }
  .by-input__inner {
    cursor: pointer;
    text-align: center;
    height: 100%;
    background-color: #89a4d7;
    border: none;
    box-sizing: border-box;
    color: #fff;
    display: inline-block;
    font-size: inherit;
    line-height: 100%;
    outline: none;
    flex: 1;
    width: 100%;
    &:focus {
      // border-color: red !important;
      outline: none !important;
    }
  }
}

.by-autocomplete {
  & /deep/ .el-autocomplete-suggestion__wrap {
    max-height: 400px;
    padding: 0;
    overflow-x: hidden;
  }

  & /deep/ .el-autocomplete-suggestion__list {
    background-color: #89a4d7;
    // padding: 0 20px;
  }
  .li-item {
    height: 39px;
    color: #ffffff;
    font-size: 14px;
    line-height: 39px;
    text-align: center;
    &:hover {
      cursor: pointer;
      background: #acbfe3;
    }
  }
  .li-nodata {
    text-align: center;
  }
}

.by-autocomplete /deep/ .svgicon {
    transition: all .2s;

  }
// 弹框打开时
.autocomplete__open {
  position: relative;
  .input-container {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .by-input__inner {
    &:focus {
      border-radius: 0px !important;
      border-color: #fff !important;
    }
  }
  .by-autocomplete-suggestion {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    overflow: hidden;
    position: absolute;
    width: 100%;
    z-index: 1;
  }
  & /deep/ .svgicon {
    transform: rotate(180deg);
    
  }
}

</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/CheckSelect.vue